import { Money } from '../ui/Money';
import React from 'react';
import { Input } from '../ui/input';
import { Label } from '../ui/label';

const SalarySection = ({ formData, handleNestedChange, handleChange }) => {
  const totalSalary = formData.salary.basic + formData.salary.housing + formData.salary.transportation + formData.salary.other;

  return (
    <div>
      <h3 className="text-lg font-semibold mb-4">Salary Components (AED)</h3>
      <div className="bg-blue-50 p-4 rounded-lg mb-4 border border-blue-200">
        <p className="text-sm text-gray-600">Total Monthly Salary</p>
        <p className="text-2xl font-bold text-blue-600" data-testid="total-salary-display">
          <Money value={totalSalary} />
        </p>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
          <Label>Basic Salary * (Required)</Label>
          <Input 
            type="number" 
            required 
            value={formData.salary.basic} 
            onChange={(e) => handleNestedChange('salary', 'basic', parseFloat(e.target.value) || 0)} 
            data-testid="salary-basic-input"
          />
        </div>
        <div>
          <Label>Housing Allowance (Optional)</Label>
          <Input 
            type="number" 
            value={formData.salary.housing} 
            onChange={(e) => handleNestedChange('salary', 'housing', parseFloat(e.target.value) || 0)} 
            data-testid="salary-housing-input"
          />
        </div>
        <div>
          <Label>Transportation Allowance (Optional)</Label>
          <Input 
            type="number" 
            value={formData.salary.transportation} 
            onChange={(e) => handleNestedChange('salary', 'transportation', parseFloat(e.target.value) || 0)} 
            data-testid="salary-transportation-input"
          />
        </div>
        <div>
          <Label>Other Allowances (Optional)</Label>
          <Input 
            type="number" 
            value={formData.salary.other} 
            onChange={(e) => handleNestedChange('salary', 'other', parseFloat(e.target.value) || 0)} 
            data-testid="salary-other-input"
          />
        </div>
      </div>

      <div className="mt-4 bg-emerald-50 p-4 rounded-lg border border-emerald-200">
        <Label className="font-semibold text-emerald-800">Salary as per Labour Contract (AED)</Label>
        <p className="text-xs text-gray-500 mb-2">The salary registered in the employee's MOL labour contract (tracked separately from payroll components).</p>
        <Input 
          type="number"
          min={0}
          value={formData.labour_contract_salary ?? ''}
          onChange={(e) => handleChange('labour_contract_salary', e.target.value)}
          placeholder="e.g. 4000"
          className="bg-white max-w-xs"
          data-testid="labour-contract-salary-input"
        />
      </div>
    </div>
  );
};

export default SalarySection;
